import { GearSix } from '@phosphor-icons/react';

export default GearSix;
